// @flow

import * as React from 'react';
import {useState} from 'react';
import {ReactFlowProvider} from 'react-flow-renderer';
import {OnlyRenderOnClient} from 'docs/components';
import {SequenceDiagramProvider} from 'docs/data/diagram/sequence-diagram/SequenceDiagramProvider';
import Box from 'sail/Box';
import {DiagramContent} from './DiagramContent';
import type {DiagramType, DiagramPositioning} from './types';
import './Diagram.scss';

type DiagramProps = {|
  type: DiagramType,
  positioning: DiagramPositioning,
  description: string,
  elements: Array<any>,
|};

export const DiagramLoadingSkeleton = () => (
  <Box className="Diagram--loading" background="gray100">
    <Box className="Diagram--loading-overlay" background="surface" />
  </Box>
);

export const Diagram = ({
  type,
  positioning,
  description,
  elements,
}: DiagramProps) => {
  const [loading, setLoading] = useState(true);
  return (
    <Box className="Diagram" margin={{vertical: 20}}>
      {loading && <DiagramLoadingSkeleton />}
      <OnlyRenderOnClient>
        <ReactFlowProvider>
          <SequenceDiagramProvider>
            <DiagramContent
              type={type}
              positioning={positioning}
              description={description}
              initialElements={elements}
              setLoading={setLoading}
            />
          </SequenceDiagramProvider>
        </ReactFlowProvider>
      </OnlyRenderOnClient>
    </Box>
  );
};
